"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = void 0;
/**
 * Exposes the currently supported user IDs.
 */
exports.config = {
    emailUserIdHashed: 'uid'
};
